export function getTextViewerMargin({
  marginLevel,
  width,
  isMobile,
}: {
  marginLevel: number;
  width: number;
  isMobile: boolean;
}) {
  const marginIndex = Math.max(
    Math.min(marginLevel - 1, MARGIN_X_SUM_PERCENT_LIST.length),
    0
  );
  return isMobile
    ? Math.round((width * MARGIN_X_SUM_PERCENT_LIST[marginIndex]) / 2 / 100)
    : 20 * marginIndex;
}

const MARGIN_X_SUM_PERCENT_LIST = [15, 20, 25, 30, 35];
